module.exports = __webpack_public_path__ + "static/4-e817922451b1f9f123d59f6a505c8bcb.png";